import { jsxs as e, jsx as C } from "react/jsx-runtime";
function t(l) {
  return /* @__PURE__ */ e("svg", { fill: "none", height: "30", viewBox: "0 0 30 30", width: "30", xmlns: "http://www.w3.org/2000/svg", ...l, children: [
    /* @__PURE__ */ C(
      "path",
      {
        clipRule: "evenodd",
        d: "M14.6836 29.751C15.1337 30.083 15.8864 30.083 16.3364 29.751C18.9308 27.838 26.7955 21.5947 27.6793 16.3084C28.0873 12.1624 28.0116 7.01881 27.9542 4.87416C27.9395 4.3175 27.4691 3.8735 26.9109 3.8575C21.3576 3.69384 17.8782 1.50885 16.3561 0.283524C15.9204 -0.0681406 15.2511 -0.0981404 14.7954 0.224191C13.195 1.34885 9.31049 3.65484 4.06914 3.85183C3.51097 3.8765 3.04222 4.3175 3.03054 4.87416C2.98483 7.01881 2.93279 12.1621 3.34149 16.3084C4.22528 21.5947 12.089 27.838 14.6836 29.751Z",
        fill: "white",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        clipRule: "evenodd",
        d: "M14.7489 28.7676C15.163 29.0775 15.8555 29.0775 16.2695 28.7676C18.6563 26.9821 25.8918 21.1551 26.7049 16.2212C27.0803 12.3516 27.0106 7.55089 26.9578 5.54922C26.9443 5.02966 26.5116 4.61527 25.998 4.60033C20.889 4.44758 17.6879 2.40826 16.2876 1.26462C15.8868 0.936402 15.2711 0.908402 14.8518 1.20924C13.3794 2.25893 9.80565 4.41118 4.98361 4.59505C4.47009 4.61807 4.03884 5.02966 4.0281 5.54922C3.98605 7.55089 3.93816 12.3513 4.31417 16.2212C5.12725 21.1551 12.3619 26.9821 14.7489 28.7676Z",
        fill: "#00182E",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ C("path", { d: "M11.5208 8.56416H12.8726V9.95447H11.5208V8.56416Z", fill: "white" }),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M11.6833 10.5107H13.3055V11.901L13.8462 15.2377C13.8462 15.2377 12.6615 14.1856 12.224 13.2913C11.74 12.302 11.6833 10.5107 11.6833 10.5107Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12.7657 19.1306C12.7657 19.1306 13.7099 18.0995 14.5107 17.9834C14.7797 17.9444 15.199 18.0183 15.199 18.0183L14.1176 19.1306H12.7657Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M22 9.65021C22 9.39535 21.7971 9.18907 21.5473 9.18907H19.7341V8.89898C19.9174 8.83992 20.0508 8.66724 20.0508 8.46114C20.0508 8.20628 19.8481 8 19.5981 8H11.5186C11.2682 8 11.0659 8.20645 11.0659 8.46114C11.0659 8.66723 11.1991 8.83992 11.383 8.89898V9.18907H9.45304C9.20267 9.18907 9 9.39552 9 9.65021C9 13.0001 11.4563 15.7757 14.6305 16.2099V16.211C14.6305 16.8923 14.3672 17.5608 13.8422 17.8977C13.3241 18.2298 12.7992 18.5689 12.4057 19.0777H12.3536C12.1034 19.0777 11.9009 19.2842 11.9009 19.5389C11.9009 19.7932 12.1036 20 12.3536 20H18.7322C18.9821 20 19.1849 19.7932 19.1849 19.5389C19.1849 19.284 18.9821 19.0777 18.7322 19.0777H18.643C18.2496 18.5689 17.725 18.2308 17.2071 17.8977C16.6826 17.5613 16.4184 16.8921 16.4184 16.211C16.4184 16.2084 16.4189 16.2039 16.4189 16.2039C19.5698 15.7476 22 12.9834 22 9.65021ZM19.7451 10.1543C19.7451 10.1393 19.7397 10.1261 19.7367 10.1115H21.0767C20.9351 11.8979 19.9804 13.51 18.5911 14.4957C19.3165 13.4083 19.7451 11.8992 19.7451 10.1543ZM11.9034 8.85307H12.8017V9.76216H11.9034V8.85307ZM9.92354 10.1117H11.3798C11.3774 10.1261 11.3717 10.1393 11.3717 10.1545C11.3717 11.9569 11.8166 13.5085 12.5648 14.6031C11.0915 13.6299 10.07 11.9644 9.92354 10.1117ZM12.635 13.7291C12.1932 12.8057 11.9554 11.8119 11.9103 10.5468H12.8019C12.8019 12.2866 13.1697 13.8255 13.8378 15.1718C13.3601 14.8636 12.92 14.3246 12.635 13.7291ZM14.188 18.9885H13.1076C13.694 18.4016 14.4454 18.0593 15.2661 17.9993C14.8467 18.2551 14.4804 18.5914 14.188 18.9885Z",
        fill: "url(#paint0_linear_2657_20787)"
      }
    ),
    /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ e(
      "linearGradient",
      {
        gradientUnits: "userSpaceOnUse",
        id: "paint0_linear_2657_20787",
        x1: "9.24977",
        x2: "20.5958",
        y1: "8.286",
        y2: "17.7036",
        children: [
          /* @__PURE__ */ C("stop", { stopColor: "#F5E01F" }),
          /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#FF8A00" })
        ]
      }
    ) })
  ] });
}
export {
  t as default
};
